import { useContext } from "react"
import Select from "../../../components/Select/Select"
import { StaticDataContext } from "../../../views/signup-flow/SignupFormPage/SignupFormPage"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"
import { Option } from "../../../services/ntuc/userService/staticData"

function ResidentialStatusSelectField(props: FormFieldProps<Option>) {
    const { dependentField } = props
    const staticData = useContext(StaticDataContext)

    const PERMANENT: Readonly<string[]> = [`SC`, `PR`]
    const TEMPORARY: Readonly<string[]> = [`EP`, `WP`, `DP`, `LT`, `SP`]

    const filterOptions = () => {
        const REGEX = /^S|^T/i

        if (!staticData) {
            return []
        } else if (dependentField) {
            if (REGEX.test(dependentField)) {
                return staticData.residential_status.filter(element => PERMANENT.includes(element.code))
            } else {
                return staticData.residential_status.filter(element => TEMPORARY.includes(element.code))
            }
        } else {
            return staticData.residential_status
        }
    }

    return (
        <Select
            {...props}
            label="residential_status"
            options={filterOptions()}
        />
    )
}

export default ResidentialStatusSelectField
